module.exports = __webpack_public_path__ + "img/home_Last_img_4.bc0c0aeb.png";